<template>
  <div>
    <div
      v-if="!configuration.cookiesStrictMode && !cookiesBannerAccepted"
      class="cookies-banner d-flex justify-center align-center flex-wrap background-post-background color-post-text pa-3 text-center gap-2"
    >
      <span>{{ $translate("CookiesBanner.weUseEssentialCookies") }}</span>
      <a class="font-weight-bold text-decoration-underline color-post-tint" href="/privacy_policy" target="_blank">
        {{ $translate("CookiesBanner.learnMore") }}
      </a>
      <the-button small @click="setCookiesBannerAccepted">{{ $translate("common.ok") }}</the-button>
    </div>
    <message-dialog v-if="configuration.cookiesStrictMode && !cookiesRestrictionLevelDialogDismissed" :dialog="true" persistent disable-content-padding>
      <template #title>
        <div class="font-size-title-big">
          {{ $translate("CookiesBanner.weCareAboutYourPrivacy") }}
        </div>
        <div class="font-size-big font-weight-normal">
          <span>{{ $translate("CookiesBanner.weUseEssentialCookies") }}</span>
          <a class="font-weight-bold text-decoration-underline color-post-tint ml-1" href="/privacy_policy" target="_blank">
            {{ $translate("CookiesBanner.learnMore") }}
          </a>
        </div>
      </template>
      <template #content>
        <div class="content-container px-4" :class="{ mobile: $vuetify.display.mobile }">
          <app-card border-always no-shadow>
            <v-card-text>
              <div class="font-size-title-small font-weight-bold mb-2">{{ $translate("common.essentialCookies") }}</div>
              <div>{{ $translate("CookiesBanner.theseCookies") }}</div>
              <div class="d-flex align-center gap-2 font-weight-bold mt-4">
                <i-custom-timer />
                <div>{{ $translate("common.userSession") }}</div>
              </div>
              <div class="ml-6">{{ $translate("common.keepsYouLoggedIn") }}</div>
            </v-card-text>
          </app-card>
          <app-card border-always no-shadow class="mt-4 mb-4">
            <v-card-text>
              <div class="font-size-title-small font-weight-bold mb-2">{{ $translate("common.optionalCookies") }}</div>
              <div>{{ $translate("CookiesBanner.theseEnhance") }}</div>

              <div class="d-flex align-center gap-2 font-weight-bold mt-4">
                <i-custom-refresh />
                <div>{{ $translate("common.appState") }}</div>
              </div>
              <div class="ml-6">{{ $translate("common.usesLocalStorage") }}</div>
              <ul class="ml-6">
                <li>{{ $translate("common.userInterface") }}</li>
                <li>{{ $translate("common.featureConfiguration") }}</li>
              </ul>
            </v-card-text>
          </app-card>
        </div>
      </template>
      <template #action-buttons>
        <div class="d-flex gap-2" :class="{ 'flex-column': $vuetify.display.mobile }">
          <the-button :small="$vuetify.display.mobile" secondary @click="onDialogCancel">{{ $translate("CookiesBanner.declineOptionalCookies") }}</the-button>
          <the-button :small="$vuetify.display.mobile" secondary @click="onDialogOk">{{ $translate("CookiesBanner.acceptAllCookies") }}</the-button>
        </div>
      </template>
    </message-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"
import { useAppStateStore } from "@/store/appState.js"

import { cookiesRestrictionLevels } from "@/constants/cookiesRestrictions.js"

export default {
  data() {
    return {
      cookiesRestrictionLevels
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    ...mapState(useAppStateStore, ["cookiesRestrictionLevelDialogDismissed", "cookiesBannerAccepted"])
  },
  methods: {
    ...mapActions(useAppStateStore, ["setCookiesBannerAccepted", "setCookiesRestrictionLevel", "setCookiesRestrictionLevelDialogDismissed"]),
    onDialogOk() {
      this.setCookiesRestrictionLevel(cookiesRestrictionLevels.allow_all)
      this.setCookiesBannerAccepted()
      this.setCookiesRestrictionLevelDialogDismissed()
    },
    onDialogCancel() {
      this.setCookiesRestrictionLevel(cookiesRestrictionLevels.allow_essentials)
      this.setCookiesRestrictionLevelDialogDismissed()
    }
  }
}
</script>

<style scoped>
.cookies-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 60px;
  z-index: var(--z-index-popups);
}

.content-container.mobile {
  max-height: 320px;
}
</style>
